import React, {PureComponent} from 'react';

import {breakpoints, CustomPropShapes} from '../../constants';
import ResizeManager from './ResizeManager';

export const propTypes = {
    breakpoint: CustomPropShapes.oneOfConstant(breakpoints.name)
};

export const DEFAULT_SIZE_PROPS = {
    dimensions: {
        height: 0,
        width: 0
    },
    breakpoint: breakpoints.name.XSMALL,
    hasMeasured: false
};

const WithWindow = WrappedComponent =>
    class extends PureComponent {
        state = this.getInitialSizeProps();

        componentDidMount() {
            this.key = ResizeManager.subscribe(this.onResize);
        }

        componentWillUnmount() {
            ResizeManager.unsubscribe(this.key);
        }

        getInitialSizeProps() {
            const resizeManagerProps = ResizeManager.getProps();

            if (resizeManagerProps) {
                return {
                    ...resizeManagerProps,
                    hasMeasured: true
                };
            }

            return DEFAULT_SIZE_PROPS;
        }

        onResize = ({breakpoint, dimensions}) => {
            this.setState({
                breakpoint,
                dimensions,
                hasMeasured: true
            });
        };

        render() {
            const {breakpoint, dimensions, hasMeasured} = this.state;

            return (
                <WrappedComponent
                    breakpoint={breakpoint}
                    dimensions={dimensions}
                    hasMeasured={hasMeasured}
                    {...this.props}
                />
            );
        }
    };

export default WithWindow;
